import styles from './SegmentedBar.module.css';

export interface Segment {
	key?: string;
	label: string;
	value: number;
	title?: string;
}

const SEGMENT_COLORS = [
	'var(--color-teal-600)',
	'var(--color-stone-500)',
	'var(--color-teal-400)',
	'var(--color-stone-400)',
	'var(--color-teal-200)',
];

export function getSegmentColor(index: number): string {
	return SEGMENT_COLORS[index % SEGMENT_COLORS.length] ?? 'var(--color-teal-600)';
}

export function SegmentedBar({
	segments,
	denominator,
}: {
	segments: Segment[];
	/** Pin the divisor instead of using the sum. Use when the canonical total is
	 *  known independently (e.g. variant weights in 0–10000 space). */
	denominator?: number;
}) {
	const sum = segments.reduce((acc, s) => acc + s.value, 0);
	const total = denominator ?? sum;

	return (
		<div className={styles.bar}>
			{segments.map((segment, index) => {
				const pct = total > 0 ? (segment.value / total) * 100 : 0;
				const displayPct = pct.toFixed(1);
				const isNarrow = pct < 15;
				const label = segment.label || '';
				return (
					<div
						key={segment.key ?? `${label}-${index}`}
						className={styles.segment}
						style={{ width: `${pct}%`, backgroundColor: getSegmentColor(index) }}
						title={segment.title ?? `${label}: ${displayPct}%`}
					>
						<span className={styles.segmentText}>
							{isNarrow ? `${displayPct}%` : `${label} (${displayPct}%)`}
						</span>
					</div>
				);
			})}
			{sum === 0 && <div className={styles.empty} />}
		</div>
	);
}
